import React, { FC } from 'react';
import Image from 'next/image';
import cx from 'classnames';
import useThemeBlock from '@/hooks/useThemeBlock';
import block from './block.json';
import { getStyles } from './styles.css';

export type PageHeaderSimpleProps = {
	variant?: string;
	title: string;
	mediaSrc?: string;
	isPost?: boolean;
} & ThemeProps;

/**
 * COMPONENT
 */
export const PageHeaderSimple: FC<PageHeaderSimpleProps> & BlockConfigs = ({
	title,
	isPost,
	mediaSrc,
	variant: currentVariant = 'default',
	theme = {},
}) => {
	const { variant, blockTheme } = useThemeBlock(
		block.slug,
		theme,
		currentVariant
	);

	const htmlProps = {
		'data-variant': variant,
	};

	const rootClass = cx(
		'supt-pageHeader supt-pageHeaderSimple',
		isPost && 'supt-pageHeaderSimple--isPost',
		`supt-pageHeader--${variant}`,
		getStyles(blockTheme)
	);

	return (
		<div className={rootClass} data-block={block.slug} {...htmlProps}>
			<div className="supt-pageHeaderSimple__inner">
				<h1 className="supt-pageHeaderSimple__title">{title}</h1>
			</div>
			{mediaSrc && (
				<div className="supt-pageHeaderSimple__imageWrapper">
					<Image
						src={mediaSrc}
						alt=""
						layout="fill"
						objectFit="cover"
						priority
					/>
				</div>
			)}
		</div>
	);
};

PageHeaderSimple.slug = block.slug;
PageHeaderSimple.title = block.title;
